export default __webpack_public_path__ + "static/media/005-bridge.db7874c5.svg";